type StaffAlertProps = {
  variant?: "error" | "info" | "success";
  title?: string;
  children: React.ReactNode;
  onDismiss?: () => void;
};

export function StaffAlert({ variant = "error", title, children, onDismiss }: StaffAlertProps) {
  return (
    <div className={`staff-alert staff-alert--${variant}`} role="alert">
      <div className="staff-alert__body">
        {title ? <strong className="staff-alert__title">{title}</strong> : null}
        <p className="staff-alert__text">{children}</p>
      </div>
      {onDismiss ? (
        <button type="button" className="staff-alert__dismiss" onClick={onDismiss} aria-label="Dismiss">
          ×
        </button>
      ) : null}
    </div>
  );
}
